// extracted by mini-css-extract-plugin
module.exports = {"pricingRow":"BogoPricingRows_pricingRow__jV4Jc"};